import { call, put, takeEvery } from "redux-saga/effects";
import { competitionsRequest } from "../../api/competitions";
import { COMPETITIONS_REQUEST } from "../../constants/competitions";
import { competitionsActions } from "../../store/competitions/actions";

function* competitionsRequestSaga(action: any): any {
  try {
    const competitions = yield call(competitionsRequest, action.payload);
    yield put(competitionsActions.competitionsSuccessAction(competitions));
  } catch (e: any) {
    yield put(competitionsActions.competitionsFailureAction(e));
  }
}
function* competitionsSaga() {
  yield takeEvery(COMPETITIONS_REQUEST, competitionsRequestSaga);
}

export default competitionsSaga;
